import React, { useEffect, useState } from 'react' //lazy
import { useHistory } from 'react-router-dom'
import { UrlInternal } from 'common/constants/endpoints'
import { useDispatch } from 'react-redux'
import { getListCasino } from 'apis'
import openBtn from 'assets/images/button/openBtn.png'
import closeBtn from 'assets/images/button/closebtn.png'

/** Call API */
import // dadasdsa
'apis'

import * as S from './style'

const BoxItem = (props: any) => {
  const { img, data, category, imgBackThumbail, page } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const [gameMain, setGameMain] = useState<any>([])
  const [loadMore, setLoadMore] = useState<any>({
    liveCasino: false,
    sportGame: false,
    miniGame: false,
    slotGame: false
  })

  const getGamesMain = async () => {
    dispatch({ type: 'WAITTING' })
    try {
      const res: any = await getListCasino()
      if (res.result === false) {
        alert(res.message)
        dispatch({ type: 'STOP_WAITTING' })
      } else {
        setGameMain(res)
        dispatch({ type: 'STOP_WAITTING' })
      }
    } catch (error) {
      console.log(error)
      dispatch({ type: 'STOP_WAITTING' })
    }
  }
  const handleButtonClick = (category: string) => {
    const updatedLoadMore = { ...loadMore, [category]: true }
    setLoadMore(updatedLoadMore)
  }
  const handleButtonCloseClick = (category: string) => {
    const updatedLoadMore = { ...loadMore, [category]: false }
    setLoadMore(updatedLoadMore)
  }
  const LinkBanner = (e: any, gameType: string) => {
    if (gameType !== UrlInternal.SPORT.split('/')[1]) {
      history.push(`${UrlInternal.HOME}${gameType}`)
    } else {
      history.push(`${UrlInternal.SPORT_SOLO_ROUTER}`)
    }
  }

  const handleLaunchGane = (v: any) => {
    v?.game_code
      ? window.open(
          `${UrlInternal.BLANK_ROUTER}vendor=${v.code}&game_code=${v.game_code}&type=${v.type}`,
          '',
          "width=1500,height='100vh'"
        )
      : history.push(
          `${UrlInternal.CASINO}?type=${v.type}&code=${v.code}&page=${page}`
        )
  }

  // useEffect(() => {
  //   getGamesMain()
  // }, [])
  // useEffect(() => {}, [loadMore])

  return (
    <>
      <S.LiveCasino>
        <div className='GroupLine'>
          <img alt='line1' className='line' src={img} />
        </div>
        {loadMore.liveCasino ? (
          <>
            <S.ListItemBox>
              {data.map((v: any, i: number) => (
                <div className='flip-card' key={i}>
                  <div className='flip-card-inner'>
                    <S.ListItem
                      className='flip-card-front item'
                      key={i}
                      onClick={() => handleLaunchGane(v)}
                    >
                      <div className='thumb-ct'>
                        <img alt='' src={v.image} />
                      </div>
                      <div className='txt'>
                        <div className='title'>{v.name}</div>
                      </div>
                    </S.ListItem>
                    <S.ListItem
                      className='flip-card-back item'
                      key={i}
                      onClick={() => handleLaunchGane(v)}
                    >
                      <div className='thumb-ct'>
                        <img alt='' src={imgBackThumbail} />
                      </div>
                      <div className='txt'>
                        <div className='title'>{v.name}</div>
                      </div>
                    </S.ListItem>
                  </div>
                </div>
              ))}
            </S.ListItemBox>
            <div className='viewMore'>
              <button onClick={() => handleButtonCloseClick(category)}>
                닫기
              </button>
            </div>
            {/* <img
              src={closeBtn}
              alt='button'
              className='btn'
              onClick={() => handleButtonCloseClick(category)}
            /> */}
          </>
        ) : (
          <>
            <S.ListItemBox>
              {data.slice(0, 12).map((v: any, i: number) => (
                <div className='flip-card' key={i}>
                  <div className='flip-card-inner'>
                    <S.ListItem
                      className='flip-card-front item'
                      key={i}
                      onClick={() => handleLaunchGane(v)}
                    >
                      <div className='thumb-ct'>
                        <img alt='' src={v.image} />
                      </div>
                      <div className='txt'>
                        <div className='title'>{v.name}</div>
                      </div>
                    </S.ListItem>
                    <S.ListItem
                      className='flip-card-back item'
                      key={i}
                      onClick={() => handleLaunchGane(v)}
                    >
                      <div className='thumb-ct'>
                        <img
                          src={imgBackThumbail}
                          alt='button'
                          className='btn'
                        />
                      </div>
                      <div className='txt'>
                        <div className='title'>{v.name}</div>
                      </div>
                    </S.ListItem>
                  </div>
                </div>
              ))}
            </S.ListItemBox>
            <div className='viewMore'>
              <button onClick={() => handleButtonClick(category)}>
                더보기
              </button>
            </div>
            {/* <img
              src={openBtn}
              alt='button'
              className='btn'
              onClick={() => handleButtonClick(category)}
            /> */}
          </>
        )}
      </S.LiveCasino>
    </>
  )
}

export default BoxItem
